// extracted by mini-css-extract-plugin
export var content = "_cg-3";
export var list = "_cg-4";
export var settingsContent = "_cg-7";
export var settingsPanel = "_cg-8";
export var state = "_cg-6";
export var triggerBadge = "_cg-2";
export var triggerButton = "_cg-1";
export var triggerShell = "_cg-0";
export var unreadDot = "_cg-5";